import React from 'react';

import { IBagProps } from './types';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconBag: React.FC<IBagProps> = ({
  // smallSize is passed for plk brand bag icon and is not a known dom attribute
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  smallSize,
  ...props
}) => (
  <svg viewBox="0 0 70 72" {...props}>
    <title>Bag Icon</title>
    <path d="M20.6818183,14.3999998 C20.6818184,6.44709947 27.0922867,0 35.0000001,0 C42.9077135,0 49.3181818,6.44709947 49.3181819,14.3999998 L60.4545455,14.3999998 C65.7263545,14.3999998 70.0000001,18.6980662 70.0000001,24 L70.0000001,62.3999998 C70.0000001,67.7019334 65.7263545,72 60.4545455,72 L9.54545463,72 C4.27364566,72 8.52999946e-08,67.7019334 8.52999946e-08,62.3999998 L8.52999946e-08,24 C8.52999946e-08,18.6980662 4.27364566,14.3999998 9.54545463,14.3999998 L20.6818183,14.3999998 Z M23.8636364,14.3999998 L46.1363637,14.3999998 C46.1363637,8.21441068 41.1504438,3.20000002 35.0000001,3.20000002 C28.8495564,3.20000002 23.8636364,8.21441068 23.8636364,14.3999998 L23.8636364,14.3999998 Z" />
  </svg>
);

export default IconBag;
